import React, { useState, useEffect, useRef, useMemo } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ConfigurationReportTab from './configurationTab';
import Sorting from '../../components/company_panel/common/sorting';
import { capitalizeAllFirstLetters, capitalizeFirstLetter, formateDate, formateDateWithMonth, formateDateWithTime, formatToTwoDecimals, getBrandId, getCompany, getOutletId, showPrice, getExcelColumnWidths } from '../../helpers/commonFunctions';
import CustomPagination from '../../components/company_panel/common/custompagination';
import Loader from '../../components/company_panel/common/loader';
import notFound from '../../../src/assets/company/img/no-record-found.png'
import CustomRangepicker from '../../components/company_panel/common/rangepicker';
import { ListInventoryReport, StockMovementReport } from '../../services/company_panel/report.services';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { LOADER_TIME } from '../../utils/Constants';
import $ from "jquery";
import { GetParentCategories } from '../../services/company_panel/categoryService';
import { GetAllSuppliers } from '../../services/company_panel/supplierService';
import Swal from 'sweetalert2';
import { lastBusinessDate } from '../../services/company_panel/outletService';
import GlobalLoader from '../../components/company_panel/common/globalLoader';


const StockMovementReportList = () => {

    const breadcrumbs = [{ title: "Dashboard", url: "/company/dashboard" }, { title: "Pages", url: "" },]
    const [list, setList] = useState([])
    const [dataLength, setDataLength] = useState()
    const [itemPerPage, setItemPerPage] = useState(10)
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true)
     const [globalLoader, setGlobalLoader] = useState(false);
    const [search, setSearch] = useState({})
    const [globalSearch, setGlobalSearch] = useState("")
    const [resetdate, setResetDate] = useState(false);
    const selectRef = useRef(null);
    const [orderType, setOrderType] = useState();

    const params = useParams();
    const [categoryData, setCategoryData] = useState([]);
    const [supplier, setSupplier] = useState({});

    const [isBrandChanged, setIsBrandChanged] = useState(false);
    const [isOutletChanged, setIsOutletChanged] = useState(false);

    const [businessDate, setBusinessDate] = useState({});

    useMemo(() => {
        document.addEventListener('brand-changed', function () {
            setIsBrandChanged(!isBrandChanged);
        });
        document.addEventListener('outlet-changed', function () {
            setIsOutletChanged(!isOutletChanged);
        })
    });

    useEffect(() => {
        if (search) {
            setLoader(true)
            setTimeout(() => {
                const formData = new FormData()
                formData.append("page", page)
                formData.append("per_page", itemPerPage)
                formData.append("sort", JSON.stringify(sorting))
                formData.append("search", JSON.stringify(search))
                formData.append("global_search", globalSearch)
                formData.append('outlet_id', getOutletId());
                formData.append('company_id', getCompany().company_id);
                StockMovementReport(formData).then(data => {
                    setDataLength(data?.data?.response?.count || 0);
                    setList(data?.data?.response?.rows || [])
                    setLoader(false);
                }).catch(error => {
                    console.log("error ====> ", error);
                    setList([]);
                    setDataLength(0);
                    Swal.fire({
                        customClass: 'swal-wide',
                        position: 'absolute',
                        icon: 'error',
                        title: error?.response?.data?.errors?.message || error?.message,
                        showConfirmButton: false,
                        timer: 1000,
                        toast: true,
                        position: 'top-right',
                    })
                    setLoader(false);
                })
            }, 500);
        }
    }, [sorting, search, globalSearch, page, isBrandChanged, isOutletChanged])

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    }

    const resetFilter = (e) => {
        e.preventDefault()
        setGlobalSearch("")
        prepareSearch()
        setSearch({})
        setResetDate(!resetdate)
        // $("#dateFilter")[0].selectedIndex = 0
        // $("#resetFilter")[0].selectedIndex = 0
        // $("#supplierFilter")[0].selectedIndex = 0
    }

    const headerMapping = {
        "business_date": "Business Date",
        "brand": "Brand",
        "area": "Area",
        "store_short_code": "Store Short Code",
        "outlet_name": "Outlet",
        "category_name": "Category",
        "sub_category_name": "Sub Category",
        "sku": "SKU",
        "inventory_id": "Inventory Id",
        "inventory_name": "Inventory",
        "uom": "UOM",
        "unit_price": "Unit Price",

        "opening_qty": "Opening Balace (QTY)",
        "purchase_qty": "Direct Purchase (QTY)",
        "transfer_in_qty": "All Transfer In (QTY)",
        "total_in_qty": "Total In (+)",
        "transfer_out_qty": "All Transfer Out (QTY)",
        "wastage_qty": "Wastage",
        "ideal_sold_qty": "Ideal Sold (QTY)",
        "total_out_qty": "Total Out (-)",
        "system_in_hand_qty": "System On Hand",
        "physical_remaining_count": "Actual Store Count",
        "variance_qty": "Variance (QTY)",
        "variance_amount": "Variance Amount",
        "wastage_cost": "Wastage Cost",
        "actual_used_qty": "Actual Used (QTY)",
        "actual_used_cost": "Actual Used Cost",
        "standard_used_cost": "Standard Used Cost"
    };

    const handleExport = () => {
        setGlobalLoader(true);
        const formData = new FormData()
        formData.append("page", 1)
        formData.append("per_page", dataLength)
        formData.append("sort", JSON.stringify(sorting))
        formData.append("search", JSON.stringify(search))
        formData.append("global_search", globalSearch)
        formData.append('outlet_id', getOutletId());
        formData.append('company_id', getCompany().company_id);

        StockMovementReport(formData).then(data => {
            setDataLength(data.data.response.count);
            const listData = data && data.data && data.data.response ? data.data.response.rows : [];
            const printData = listData.map((item) => {
                const transformedItem = {};
                // Extract fields from nested objects
                const businessDate = item?.business_date ? formateDate(item?.business_date) : 'N/A';
                const brand = item?.brand_name || "N/A";
                const area = item?.area_name || "N/A";
                const storeShortCode = item?.short_code || "N/A";
                const OutletName = capitalizeFirstLetter(item?.outlet_name) || 'N/A'
                const category = item?.category_name || 'N/A';
                const subCategory = item?.sub_category_name || 'N/A';
                const SKU = item?.inventory_sku || 'N/A';
                const inventoryId = `#${item?.inventory_id}` || 'N/A';
                const inventoryName = item?.inventory_name || 'N/A';
                const UOM = item?.uom_code || 'N/A';
                const unitPrice = item?.raw_material_price || 'N/A';

                const openingBalance = item?.opening_qty || 0;
                const directPurchase = item?.purchase_qty || 0;
                const allTransferIn = item?.transfer_in_qty || 0;
                const totalIn = item?.total_in_qty || 0;
                const allTransferOut = item?.transfer_out_qty || 0;
                const wastage = item?.wastage_qty || 0;
                const idealSold = item?.ideal_sold_qty || 0;
                const totalOut = item?.total_out_qty || 0;
                const systemOnHand = item?.system_in_hand_qty || 0;
                const actualStoreCount = item?.physical_remaining_count || 0;
                const variance = item?.variance_qty || 0;
                const varianceAmount = item?.variance_amount || 0;
                const wastageCost = item?.wastage_cost || 0;
                const actualUsed = item?.actual_used_qty || 0;
                const actualUsedCost = item?.actual_used_cost || 0;
                const standardUsedCost = item?.standard_used_cost || 0;


                // Map fields according to headerMapping
                for (const key in headerMapping) {
                    if (headerMapping.hasOwnProperty(key)) {
                        const newKey = headerMapping[key];
                        switch (key) {
                            case "business_date":
                                transformedItem[newKey] = businessDate;
                                break;
                            case "brand":
                                transformedItem[newKey] = capitalizeFirstLetter(brand);
                                break;
                            case "area":
                                transformedItem[newKey] = capitalizeFirstLetter(area);
                                break;
                            case "store_short_code":
                                transformedItem[newKey] = storeShortCode
                                break;
                            case "outlet_name":
                                transformedItem[newKey] = capitalizeFirstLetter(OutletName)
                                break;
                            case "category_name":
                                transformedItem[newKey] = capitalizeFirstLetter(category)
                                break;
                            case "sub_category_name":
                                transformedItem[newKey] = capitalizeFirstLetter(subCategory)
                                break;
                            case "sku":
                                transformedItem[newKey] = SKU
                                break;
                            case "inventory_id":
                                transformedItem[newKey] = inventoryId
                                break;
                            case "inventory_name":
                                transformedItem[newKey] = capitalizeFirstLetter(inventoryName)
                                break;
                            case "uom":
                                transformedItem[newKey] = UOM
                                break;
                            case "unit_price":
                                transformedItem[newKey] = unitPrice
                                break;
                            case "opening_qty":
                                transformedItem[newKey] = openingBalance
                                break;
                            case "purchase_qty":
                                transformedItem[newKey] = directPurchase
                                break;
                            case "transfer_in_qty":
                                transformedItem[newKey] = allTransferIn
                                break;
                            case "total_in_qty":
                                transformedItem[newKey] = totalIn
                                break;
                            case "transfer_out_qty":
                                transformedItem[newKey] = allTransferOut
                                break;
                            case "wastage_qty":
                                transformedItem[newKey] = wastage
                                break;
                            case "ideal_sold_qty":
                                transformedItem[newKey] = idealSold
                                break;
                            case "total_out_qty":
                                transformedItem[newKey] = totalOut
                                break;
                            case "system_in_hand_qty":
                                transformedItem[newKey] = systemOnHand
                                break;
                            case "physical_remaining_count":
                                transformedItem[newKey] = actualStoreCount
                                break;
                            case "variance_qty":
                                transformedItem[newKey] = variance
                                break;
                            case "variance_amount":
                                transformedItem[newKey] = `${showPrice(varianceAmount)} SAR`;
                                break;
                            case "wastage_cost":
                                transformedItem[newKey] = `${showPrice(wastageCost)} SAR`;
                                break;
                            case "actual_used_qty":
                                transformedItem[newKey] = actualUsed
                                break;
                            case "actual_used_cost":
                                transformedItem[newKey] = `${showPrice(actualUsedCost)} SAR`;
                                break;
                            case "standard_used_cost":
                                transformedItem[newKey] = `${showPrice(standardUsedCost)} SAR`;
                                break;

                            default:
                                // Handle any unexpected keys
                                console.warn(`Unexpected key in headerMapping: ${key}`);
                                transformedItem[newKey] = 'N/A';
                                break;
                        }
                    }
                }
                return transformedItem;
            });

            const ws = XLSX.utils.json_to_sheet(printData, { header: Object.values(headerMapping) });
            ws['!cols'] = getExcelColumnWidths(printData, Object.values(headerMapping));
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            saveAs(blob, 'Stock-Movement-Report.xlsx');
            // setTimeout(() => {
            //     setLoader(false);
            // }, LOADER_TIME);
            setGlobalLoader(false);
        }).catch(error => {
            // setTimeout(() => {
            //     setLoader(false);
            // }, LOADER_TIME);
            console.log("error ====> ", error);
            setGlobalLoader(false);
        })
    };

    const handleFilterChange = (e) => {
        if (e?.target.value) {
            prepareSearch("category_id", e.target.value);
        } else {
            prepareSearch("category_id", "");
        }
    };

    const handleFilterChangeSupplier = (e) => {
        if (e?.target.value) {
            prepareSearch("supplier_id", e.target.value);
        } else {
            prepareSearch("supplier_id", "");
        }
    };

    useEffect(() => {
        const formData = new FormData()
        formData.append('brand_id', getBrandId());
        GetParentCategories(formData).then(data => {
            setCategoryData(data && data.data && data.data.response ? data.data.response.rows : [])
        }).catch(error => {
            console.log("error ====> ", error);
        })
    }, [isBrandChanged])

    useEffect(() => {
        GetAllSuppliers({ brand_id: getBrandId() }).then(data => {
            setSupplier(data?.data?.response || []);
        }).catch(error => {
            console.log("error ====> ", error);
        });
    }, [isBrandChanged]);

    useEffect(() => {
        const formData = new FormData();
        formData.append('outlet_id', getOutletId());
    
        lastBusinessDate(formData).then(data => {
            const fetchedBusinessDates = data?.data?.response || [];
            // const latestBusinessDate =  formateDate(fetchedBusinessDates.business_date); 
            // console.log("latestBusinessDate", latestBusinessDate);
    
            // Convert latestBusinessDate to YYYY-MM-DD format if necessary
            // const formattedBusinessDate = fetchedBusinessDates.business_date ? new Date(fetchedBusinessDates.business_date).toISOString().split('T')[0] : '';
            const businessDate = new Date(fetchedBusinessDates.business_date);
            const year = businessDate.getFullYear();
            const month = String(businessDate.getMonth() + 1).padStart(2, '0');
            const day = String(businessDate.getDate()).padStart(2, '0');
            const formattedBusinessDate = `${year}-${month}-${day}`;
            
            if (formattedBusinessDate) {
                setBusinessDate(formattedBusinessDate);  
            } else {
                setBusinessDate(''); 
            }
        }).catch(error => {
            console.log("Error fetching business dates:", error); 
        });
    }, [isOutletChanged]); 


    return (
        <>
            {globalLoader && <GlobalLoader/>}
            <div className="animation_fade">
                <div className='page-header d-flex align-items-center'>
                    <div className='page-header-left'>
                        <h4>Report</h4>
                    </div>
                    <div className='page-header-right ms-auto'>
                        <button onClick={handleExport} disabled={dataLength === 0} className="btn btn-primary ms-2">Export Report</button>
                    </div>
                </div>
                <div className="card custom-card overflow-hidden">
                    <div className='gap-20 border-bottom'>
                        <div className='col-12'>
                            <div className='d-flex justify-content-between align-items-center'>
                                <ConfigurationReportTab tab='stock' />
                            </div>
                        </div>
                    </div>
                    <div className="gap-20">
                        <div className='page-header d-flex align-items-center mb-0'>
                            {/* <div className='page-header-left'></div> */}
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="form-group mb-0 rangepicker_container">
                                    <input type="search" className="form-control" value={globalSearch} placeholder="Search" onChange={(e) => { setGlobalSearch(e.target.value) }} />
                                </div>
                            </div>
                            <div className='page-header-right ms-auto'>
                                <div className='d-flex gap-3 align-items-center'>
                                    {/* <div className="date-input">
                                        <CustomRangepicker GetDateRange={(e) => { prepareSearch("created", e) }} resetdate={resetdate} />
                                    </div> */}
                                    {/* <div className="date-input" style={{ display: "flex", gap: "8px" }}>
                                        <input
                                            type="date"
                                            className="form-control"
                                            onChange={(e) => prepareSearch("business_date", e.target.value)}
                                        />
                                    </div> */}
                                    <div className="date-input" style={{ display: "flex", gap: "8px", flexDirection: "column" }}>
                                        <label htmlFor="business_date" style={{ marginBottom: "4px" }}>Business Date</label>
                                        <input
                                            id="business_date"
                                            type="date"
                                            className="form-control"
                                            onChange={(e) => prepareSearch("business_date", e.target.value)}
                                            // Disable dates after business date
                                            max={businessDate} 
                                        />
                                    </div>


                                    {/* <div className="me-3">
                                        <div className="form-group mb-0 filter_icon_container filter_design">
                                            <select
                                                ref={selectRef}
                                                className={`form-control cp ${categoryData && categoryData.length > 5 ? 'scrollable-select' : ''}`}
                                                onChange={handleFilterChange}
                                                id="resetFilter"
                                            >
                                                <option value="">Select Category</option>
                                                {categoryData &&
                                                    categoryData.length > 0 &&
                                                    categoryData.map((option, i) => {
                                                        return (
                                                            <option key={i} value={option?.id}>
                                                                {capitalizeFirstLetter(option?.name)}
                                                            </option>
                                                        );
                                                    })}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="me-3">
                                        <div className="form-group mb-0 filter_icon_container filter_design">
                                            <select
                                                ref={selectRef}
                                                className={`form-control cp ${supplier && supplier.length > 5 ? 'scrollable-select' : ''}`}
                                                onChange={handleFilterChangeSupplier}
                                                id="supplierFilter"
                                            >
                                                <option value="">Select Supplier</option>
                                                {supplier &&
                                                    supplier.length > 0 &&
                                                    supplier.map((option, i) => {
                                                        return (
                                                            <option key={i} value={option?.id}>
                                                                {capitalizeFirstLetter(option?.name)}
                                                            </option>
                                                        );
                                                    })}
                                            </select>
                                        </div>
                                    </div> */}
                                    <button type="reset" value='Reset' onClick={resetFilter} className="btn btn-primary mr-2">Reset Filter</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tabler-wrap">
                        <div className="table-responsive">
                            <table className="table table-custom">
                                <thead>
                                    <tr>
                                        <th width="10%">
                                            {/* <div className='sorting_column'> */}
                                                <span>Business Date</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventories.id" />
                                            {/* </div> */}
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Item ID</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventories.id" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Brand</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventories.item_name" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Area</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventories.item_name" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Store short code</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventories.item_name" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Outlet</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventories.item_name" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <span>Category</span>
                                        </th>
                                        <th width="10%">
                                            <span>Sub Category</span>
                                        </th>
                                        <th width="10%">
                                            <span>SKU</span>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Inventory</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventories.item_name" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>UOM</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventories.item_name" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Unit Price</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventories.item_name" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Opening Balance(QTY)</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventory_stock_histories.quantity_old" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Direct Purchase(QTY)</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventory_stock_histories.quantity_credited" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>All transfer In(QTY)</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventory_stock_histories.quantity_debited" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Total(+)</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventory_stock_histories.quantity_new" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>All Transfer Out(QTY)</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventory_stock_histories.quantity_new" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Wastage</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventory_stock_histories.quantity_new" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Ideal Sold(QTY)</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventory_stock_histories.quantity_new" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Total(-)</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventory_stock_histories.quantity_new" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>System on Hand</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventory_stock_histories.quantity_new" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Actual Store Count</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventory_stock_histories.quantity_new" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Variance(QTY) </span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventory_stock_histories.quantity_new" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Variance Amount </span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventory_stock_histories.quantity_new" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Wastage Cost </span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventory_stock_histories.quantity_new" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Actual Used(QTY) </span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventory_stock_histories.quantity_new" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Actual Used Cost</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="outlets.outlet_name" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Standard Used Cost</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventory_stock_histories.created_at" />
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ?
                                        <tr>
                                            <td colSpan={16}><Loader /></td>
                                        </tr> : <>
                                            {list.length ? list?.map((row, i) => (
                                                <tr>
                                                    <td>{formateDateWithMonth((row?.business_date))}</td>
                                                    <td>#{row?.inventory_id}</td>
                                                    <td>{capitalizeFirstLetter(row?.brand_name ? row?.brand_name : "-")}</td>
                                                    <td>{capitalizeFirstLetter(row?.area_name ? row?.area_name : "-")}</td>
                                                    <td>{capitalizeFirstLetter(row?.short_code ? row?.short_code : "-")}</td>
                                                    <td>{capitalizeFirstLetter(row?.outlet_name ? row?.outlet_name : "-")}</td>
                                                    <td>{capitalizeFirstLetter(row?.category_name ? row?.category_name : "-")}</td>
                                                    <td>{capitalizeFirstLetter(row?.sub_category_name ? row?.sub_category_name : "-")}</td>
                                                    <td>{row?.inventory_sku ? row?.inventory_sku : "-"}</td>
                                                    <td>{capitalizeFirstLetter(row?.inventory_name ? row?.inventory_name : "-")}</td>
                                                    <td>{capitalizeFirstLetter(row?.uom_code ? row?.uom_code : "-")}</td>
                                                    <td>{row?.raw_material_price ? row?.raw_material_price : 0}</td>
                                                    <td>{row?.opening_qty ? row?.opening_qty : 0}</td>
                                                    <td>{row?.purchase_qty ? row?.purchase_qty : 0}</td>
                                                    <td>{row?.transfer_in_qty ? row?.transfer_in_qty : 0}</td>
                                                    <td>{row?.total_in_qty ? row?.total_in_qty : 0}</td>
                                                    <td>{row?.transfer_out_qty ? row?.transfer_out_qty : 0}</td>
                                                    <td>{row?.wastage_qty ? row?.wastage_qty : 0}</td>
                                                    <td>{row?.ideal_sold_qty ? row?.ideal_sold_qty : 0}</td>
                                                    <td>{row?.total_out_qty ? row?.total_out_qty : 0}</td>
                                                    <td>{row?.system_in_hand_qty ? row?.system_in_hand_qty : 0}</td>
                                                    <td>{row?.physical_remaining_count ? row?.physical_remaining_count : 0}</td>
                                                    <td>{row?.variance_qty ? row?.variance_qty : 0}</td>
                                                    <td>{row?.variance_amount ? row?.variance_amount : 0}</td>
                                                    <td>{row?.wastage_cost ? row?.wastage_cost : 0}</td>
                                                    <td>{row?.actual_used_qty ? row?.actual_used_qty : 0}</td>
                                                    <td>{row?.actual_used_cost ? row?.actual_used_cost : 0}</td>
                                                    <td>{row?.standard_used_cost ? row?.standard_used_cost : 0}</td>

                                                    {/* <td>{row?.raw_material_price ? row?.raw_material_price : "-"}</td>
                                                    <td>{row?.quantity_credited ? `${formatToTwoDecimals(row?.quantity_credited)} ${row?.primary_unit_of_measure}` : "-"}</td>
                                                    <td>{row?.quantity_debited ? `${formatToTwoDecimals(row?.quantity_debited)} ${row?.primary_unit_of_measure}` : "-"}</td>
                                                    <td>{row?.quantity_new ? `${formatToTwoDecimals(row?.quantity_new)} ${row?.primary_unit_of_measure}` : "-"}</td>
                                                    <td>{row?.outlet_name ? capitalizeFirstLetter(row?.outlet_name) : "-"}</td>
                                                    <td>{row?.created_at ? formateDateWithTime(row?.created_at) : "-"}</td> */}
                                                </tr>
                                            )) : <tr>
                                                <td colSpan={16} className="text-center">
                                                    <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                    <p>No record found</p>
                                                </td>
                                            </tr>
                                            }</>}
                                </tbody>
                            </table>
                        </div>
                        <div className='tabler-footer'>
                            <div className='d-flex align-items-center'>
                                <div id="example1_info" role="status" className="table-result" aria-live="polite"><b>Total Records : {dataLength ? dataLength : "0"}</b></div>
                                {dataLength && dataLength > 0 ?
                                    <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "report", path: "/company/report/stock_movement/list" }]} /> : ""}
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer
                    position="top-right"
                    hideProgressBar={false}
                    autoClose={true | 1000}
                    newestOnTop={true}
                    closeOnClick={false}
                    draggable={false}
                    rtl={false}
                />

            </div>
        </>
    );
}

export default StockMovementReportList;